import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
  Container,
  ButtonGroup,
  Button,
  ButtonDropdown
} from "reactstrap";
import { FeedbackParent } from "../../../Constants/feedbackEnums";

type Props = {
  options: FeedbackParent[];
  value: FeedbackParent;
  onSelect: (selected: FeedbackParent) => void;
};

type State = {
  isOpen: boolean;
};

export class FeedbackParentDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  onToggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  render() {
    const styles: React.CSSProperties = {
      backgroundColor: "white",
      color: "black",
      opacity: "initial"
    };

    return (
      <ButtonGroup>
        <Button disabled style={styles}>
          Parent
        </Button>
        <ButtonDropdown id="parent-dropdown" isOpen={this.state.isOpen} toggle={this.onToggle}>
          <DropdownToggle caret>{this.props.value}</DropdownToggle>
          <DropdownMenu>
            {this.props.options.map(parent => (
              <DropdownItem key={parent} onClick={() => this.props.onSelect(parent)}>
                {parent}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </ButtonDropdown>
      </ButtonGroup>
    );
  }
}
